import React from "react";
import moment from "moment";
import Chart from "react-apexcharts";

const DailyBikeTransfer = ({ transfers }) => (
    <Chart
        options={{
            chart: {
                id: "daily-bike-transfer-bar",
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true,
                    type: "x",
                    autoScaleYaxis: false,
                    zoomedArea: {
                        fill: {
                            color: "#90CAF9",
                            opacity: 0.4
                        },
                        stroke: {
                            color: "#0D47A1",
                            opacity: 0.4,
                            width: 1
                        }
                    }
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: "50%",
                    endingShape: "arrow"
                }
            },
            stroke: {
                curve: "smooth"
            },
            xaxis: {
                categories: Object
                    .keys(transfers)
                    .map(timestamp => moment(parseInt(timestamp, 10))
                        .format("YYYY-MM-DD")),
                type: "datetime",
                labels: {
                    format: "dd MMM (ddd)"
                }
            },
            markers: {
                size: 6,
                strokeWidth: 3,
                fillOpacity: 0,
                strokeOpacity: 0,
                hover: {
                    size: 8
                }
            },
        }}
        series={[ {
            name: "Exited Bikes",
            data: Object.keys(transfers)
                .map(day => transfers[day].exitedBikes)
        }, {
            name: "Inserted Bikes",
            data: Object.keys(transfers)
                .map(day => transfers[day].insertedBikes)
        }]}
        type="line"
        width="100%"
        height={300}
    />
);

export default DailyBikeTransfer;



// WEBPACK FOOTER //
// ./src/views/pages/reports/daily-bike-transfer.js